import React, { useState, useEffect, useMemo } from "react";
import SalesSummeryBody from "./SalesSummeryBody";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Input,
  Row,
} from "reactstrap";
import {
  canceLInvoice,
  getInvoiceCopy,
  getPartyHistoryByHULCode,
  getReceivePayment,
  getTrans,
} from "../../util/APIUtils";
import "react-datepicker/dist/react-datepicker.css";
import { LoadingOverlay } from "../../util/Helpers";
import generatePDF from "./GeneratePDF";
import swal from "sweetalert";

export default function SalesSummery() {
  const [values, setValues] = useState({
    frmDate: new Date().toISOString().substring(0, 10),
    toDate: new Date().toISOString().substring(0, 10),
  });
  const [trans, setTrans] = useState({});
  const [block, setBlock] = useState(false);
  const [hide, setHide] = useState(true);
  const [paymntDetails, setPaymntDetails] = useState([]);
  const [flag, setFlag] = useState("1");
  const [partyDetails, setPartyDetails] = useState([]);


  // Fetch transaction data on component mount
  useEffect(() => {
    fetchTransactionData();
  }, []);

  const fetchTransactionData = async () => {
    setBlock(true);
    try {
      const response = await getTrans(values);
      setTrans(response);
    } catch (error) {
      swal({ text: `Unexpected Error: ${error.message}` });
    } finally {
      setBlock(false);
    }
  };

  const handleInputChange = ({ target: { name, value } }) => {
    setValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleUpdate = () => {
    if (Object.keys(values).length === 2) {
      fetchTransactionData();
      setFlag("1")
    }
  };

  const clearAll = () => {
    setValues({
      frmDate: new Date().toISOString().substring(0, 10),
      toDate: new Date().toISOString().substring(0, 10),
    });
  };

  const togglePane = () => {
    setHide((prevHide) => !prevHide);
  };

  const handleCancelInvoice = async (obj) => {
    setBlock(true);
    try {
      await canceLInvoice(obj);
      fetchTransactionData();
    } catch (error) {
      swal({ text: `Unexpected Error: ${error.message}` });
    } finally {
      setBlock(false);
    }
  };

  const handleInvoiceHistory = async (values) => {
    setBlock(true);
    try {
      const response = await getReceivePayment(values);
      setPaymntDetails(response.paymentDetails);
      setFlag("3");
      //togglePane();
    } catch (error) {
      swal({ text: `Unexpected Error: ${error.message}` });
    } finally {
      setBlock(false);
    }
  };

  const handlePartyHistory = async (hulCode) => {
    setBlock(true);
    try {
      const response = await getPartyHistoryByHULCode(hulCode);
      setPartyDetails(response);
      setFlag("4");
      //togglePane();
    } catch (error) {
      swal({ text: `Unexpected Error: ${error.message}` });
    } finally {
      setBlock(false);
    }
  };
  const handleInvoiceSoftCopy = async (values) => {
    setBlock(true);
    try {
      const response = await getInvoiceCopy(values);
      generatePDF(response);
      swal({ text: "Invoice downloaded successfully" });
    } catch (error) {
      swal({ text: `Unexpected Error: ${error.message}` });
    } finally {
      setBlock(false);
    }
  };

  const memoizedTrans = useMemo(() => trans, [trans]);

  return (
    <div>
      {block && <LoadingOverlay />}
      {hide && (
        <Card>
          <CardHeader className="carheaderSmall">
            <strong>Sales Summary</strong>
          </CardHeader>
          <CardBody>
            <Row xs="4" style={{ marginTop: "10px" }}>
              <Col>
                <Input
                  bsSize="sm"
                  type="date"
                  name="frmDate"
                  value={values.frmDate}
                  onChange={handleInputChange}
                />
              </Col>
              <Col>
                <Input
                  bsSize="sm"
                  type="date"
                  name="toDate"
                  value={values.toDate}
                  onChange={handleInputChange}
                />
              </Col>
              <Col>
                <Button className="btn-info" onClick={handleUpdate}>
                  Go
                </Button>{" "}
                <Button className="btn-warning" onClick={clearAll}>
                  Cancel
                </Button>
              </Col>
            </Row>
            <Row style={{ marginTop: "10px" }} className="align-items-stretch">
              <Col sm="4" className="d-flex">
                <Card color="primary" body className="flex-fill">
                  <Row>
                    <Col>Total Sales</Col>
                    <Col>{trans.totalSale}</Col>
                  </Row>
                  <Row>
                    <Col>Paid</Col>
                    <Col>{trans.paid}</Col>
                  </Row>
                  <Row>
                    <Col>UnPaid</Col>
                    <Col>{trans.unpaid}</Col>
                  </Row>
                </Card>
              </Col>
              <Col sm="4" className="d-flex">
                <Card
                  style={{ backgroundColor: "#7da0fa", color: "white" }}
                  body
                  className="flex-fill"
                >
                  <Row>
                    <Col>Credit Adj</Col>
                    <Col>{trans.creditAdjustments}</Col>
                  </Row>
                  <Row>
                    <Col>Outpay Adj</Col>
                    <Col>{trans.outpayAdjustments}</Col>
                  </Row>
                </Card>
              </Col>
              <Col sm="4" className="d-flex">
                <Card
                  style={{ backgroundColor: "#7978e9", color: "white" }}
                  body
                  className="flex-fill"
                >
                  <Row>
                    <Col>Vending Sales</Col>
                    <Col>{trans.vendingSaleTotal}</Col>
                  </Row>
                  <Row>
                    <Col>Sales Person</Col>
                    <Col>{trans.salesPersonsSaleTotal}</Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
      <div className="animated fadeIn">
        <SalesSummeryBody
          data={memoizedTrans}
          onHide={togglePane}
          datahandler={fetchTransactionData}
          cancelInvoice={handleCancelInvoice}
          paymntDetails={paymntDetails}
          getInvoiceHistory={handleInvoiceHistory}
          mFlag={flag}
          onMflag={setFlag}
          getInvoiceSoftCopy={handleInvoiceSoftCopy}
          getPartyHistory={handlePartyHistory}
          partyDetails={partyDetails}
        />
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/CustomComponents/SalesSummery.js